<template>
  <main class="replay-wrap"
        :class="{'is-dark': isDark}">
    <div class="main comment"
         :id="commentData.is_this_comment ? 'comment-anchor' : ''">
      <img v-lazy="commentData.avatar" class="avatar" @click="goUserDetail(commentData.uid)"/>
      <div class="right">
        <div class="username">{{ commentData.nick_name }}</div>
        <div class="content" v-if="commentData.centos && commentData.centos.text"
             v-html="transformComment(commentData.centos.text)"></div>
        <div class="pic" v-if="commentData.centos && commentData.centos.pic">
          <img @click="$emit('image', item.url)" :src="item.url" v-for="item in commentData.centos.pic" :key="item.url"
               alt="">
        </div>
        <div class="bottom">
              <span class="time">{{ commentData.created_at | convertTime }}
                              <span class="reply"
                                    @click.stop="onReply('main', commentData)"
                              >{{ $t('commentReply') }}</span>
                              <span class="reply"
                                    v-if="userInfo.id === commentData.uid"
                                    @click="doDel('main')"
                              >{{ $t('delete') }}</span>
              </span>

        </div>
      </div>
    </div>

    <div class="sub comment"
         :key="item.id"
         :id="item.is_this_reply ? 'reply-anchor' : ''"
         v-for="(item, index) in subComments">
      <img v-lazy="item.avatar" class="avatar" @click="goUserDetail(item.uid)"/>
      <div class="right">
        <div class="username">
          <span>{{ item.nick_name }}</span>
          <img v-if="item.replayed_user" src="../assets/reply.png" class="reply" alt="">
          <span v-if="item.replayed_user">{{ item.replayed_user }}</span>
        </div>
        <div class="content" v-if="item.centos && item.centos.text"
             v-html="transformComment(item.centos.text)"></div>
        <div class="pic" v-if="item.centos && item.centos.pic">
          <img @click="$emit('image', item.url)" :src="item.url" v-for="item in item.centos.pic" :key="item.url" alt="">
        </div>
        <div class="bottom">
              <span class="time">{{ item.created_at | convertTime }}
                              <span class="reply"
                                    @click.stop="onReply('sub', item)">{{ $t('commentReply') }}</span>
                                <span class="reply"
                                      v-if="userInfo.id === item.uid"
                                      @click.stop="doDel('sub', index)"
                                >{{ $t('delete') }}</span>
              </span>
        </div>

      </div>
    </div>
    <div class="display-more">
      <img class="line"
           v-if="hasExpanded || hasDisplayMore" src="../assets/more-line.png" alt="">
      <div class="expand" v-if="!noMore && hasDisplayMore"
           @click="doLoadMore">
        <span>{{ $t('commentExpandMore') }}</span>
        <img src="../assets/expand.png" alt="" class="drop">
      </div>

      <div class="collapse"
           @click="collapse"
           v-if="subComments.length > 3">
        <span>{{ $t('commentCollapse') }}</span>
        <img src="../assets/expand.png" alt="" class="drop">
      </div>
    </div>
  </main>
</template>

<script>
import { emojiTransform, linkTransform } from '@utils/emoji';
import { formatTime } from '@/utils';

export default {
  name: 'ReplyItem',
  props: {
    commentData: {
      type: Object,
      default: () => ({})
    },
    isDark: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      subComments: [],
      pressHolder: null,
      pressed: false,
      pressData: {},
      subCommentConfig: {}
    };
  },
  created () {
    this.computeSubComments();
  },
  watch: {
    'commentData.replays': {
      handler () {
        this.computeSubComments();
      },
      deep: true
    },
    pressed (val) {
      if (val) {
        this.$emit('del', {
          id: this.pressData.id,
          mainId: this.pressData.mainId || ''
        });
      }
    },
    hasExpanded () {
      this.computeSubComments();
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    hasExpanded () {
      return this.commentData.expanded;
    },
    hasDisplayMore () {
      return this.subCommentConfig.pageCount > 1;
    },
    noMore () {
      return this.subComments.length >= this.subCommentConfig.count;
    }
  },
  filters: {
    convertTime (val) {
      let _val = val;
      if (val && typeof val === 'string') {
        _val = new Date(val.replace(/-/g, '/')).getTime();
      }
      return formatTime(_val);
    }
  },
  methods: {
    doDel (type, index) {
      if (type === 'sub') {
        console.log(this.commentData.replays.list, index);
        this.$emit('del', Object.assign({
          mainId: this.commentData.id
        }, this.commentData.replays.list[index]
        ));
      } else {
        this.$emit('del', this.commentData);
      }
    },
    onMouseDown (data, event) {
      if (event.target.className === 'reply') {
        event.stopPropagation();
        event.preventDefault();
        this.onReply(data.mainId ? 'main' : 'sub', data);
        return;
      }

      this.pressed = false;
      if (this.userInfo.id !== data.uid) {
        return;
      }

      console.log('start mouse down', data);
      this.pressData = data;
      this.pressHolder = setTimeout(() => {
        this.pressed = true;
      }, 800);
    },
    onMouseUp () {
      clearTimeout(this.pressHolder);
    },
    onReply (type, data) {
      if (type === 'main') {
        this.$emit('reply', {
          ...this.commentData,
          main: {}
        });
      } else {
        this.$emit('reply', {
          ...data,
          main: this.commentData
        });
      }
    },
    goUserDetail (uid) {
      if (this.userInfo.uid !== uid) {
        this.$router.push({ path: '/userDetail', query: { uid } });
      }
    },

    collapse () {
      this.$emit('collapse');
      this.computeSubComments();
    },
    doLoadMore () {
      if (!this.hasExpanded && this.commentData.replays.list.length > this.subComments.length) {
        this.$emit('expand');
      } else {
        this.$emit('loadMore', this.commentData);
      }
    },
    computeSubComments () {
      if (this.commentData.replays) {
        this.subCommentConfig = this.commentData.replays;
        const _subComments = this.commentData.replays.list.map(item => {
          try {
            item.centos = JSON.parse(item.centos);
          } catch (e) {

          }
          return item;
        });
        this.subComments = this.hasExpanded ? _subComments : _subComments.slice(0, 3);
      }
    },
    transformComment (text) {
      // return text;
      // return text.replace(/\[.+\]/g, `<img class="emoji" src="${require('../emoji/emoji_39.png')}" />`);
      const emojiText = emojiTransform(text);
      return linkTransform(emojiText);
    }
  }
};
</script>

<style scoped lang="scss">

.comment {
  display: flex;
  width: 100%;
  margin-bottom: 16px;

  &.sub {
    padding-left: 40px;
  }

  .avatar {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    margin-right: 7px;
    border-radius: 50%;
  }

  .right {
    flex: 1;
    width: calc(100% - 40px);

    .username {
      margin-bottom: 6px;
      margin-top: 4px;
      font-family: 'PingFang SC';
      font-weight: 400;
      font-size: 13px;
      line-height: 1;
      //color: #161616;
      color: #FFFFFF;
      display: flex;

      .reply {
        width: 10px;
        height: 10px;
        margin: 0 4px;
        transform: translateY(2px);
      }
    }

    .pic {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      img {
        width: 109px;
        height: 146px;
        object-fit: contain;
        border-radius: 4px;
      }
    }

    .content {
      font-family: 'PingFang SC';
      white-space: pre-wrap;
      word-break: break-all;
      font-weight: 400;
      max-width: 100%;
      font-size: 12px;
      min-height: 18px;
      line-height: 18px;
      margin-bottom: 6px;
      //color: rgba(22, 22, 22, 0.8);
      color: rgba(255, 255, 255, 0.8);
    }

    /deep/ .mention-link {
      color: #32B8AF;
    }

    /deep/ .emoji {
      display: unset;
      width: 14px;
      height: 14px;
      transform: translateY(3px);
    }

    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .time {
        align-self: flex-end;
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 10px;
        line-height: 10px;
        //color: rgba(22, 22, 22, 0.5);
        color: rgba(255, 255, 255, 0.8);

        .reply {
          margin-left: 17px;
          color: #FFFFFFCC;
        }
      }
    }
  }
}

.display-more {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 40px;

  .line {
    width: 23px;
    height: 2px;
    margin-right: 2px;
  }

  .expand, .collapse {
    display: flex;
    font-family: 'PingFang SC';
    font-size: 12px;
    color: rgba(22, 22, 22, 0.6);

    img {
      width: 16px;
      height: 16px;
    }
  }

  .collapse {
    img {
      transform: rotateZ(180deg);
    }
  }

  .expand {
    margin-right: 30px;
  }
}

//.replay-wrap {
//  &.is-dark {
//
//    .username {
//      color: #FFFFFF !important;
//    }
//
//    .content {
//      color: rgba(255, 255, 255, 0.8) !important;
//
//    }
//
//    .bottom {
//      .time {
//        color: rgba(255, 255, 255, 0.5) !important;
//        margin-right: 17px;
//      }
//    }
//  }
//
//}
</style>
